import { z } from 'zod'

import { baseStructuredSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-structured.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'

export const supertrackerSchema = baseStructuredSchema.extend({
  instrument_type: z.literal('supertracker'),

  participation_rate: z.number(),

  knockdown_input_level: knockdownInputLevelSchema,
})

export type SupertrackerSchemaType = z.infer<typeof supertrackerSchema>
